@for (appliedRow of store.rowsSg(); let rowIdx = $index; track rowIdx) {
  <div
    #rowEl
    class="atn-ds-table-data-row"
    [class.atn-ds-table-data-row--clickable]="appliedRow.onClick"
    (click)="appliedRow.onClick && appliedRow.onClick()"
    [ngStyle]="appliedRow.css"
    (mouseenter)="store.setHoveredRow({ el: rowEl, rowRef: appliedRow })"
  >
    @if (store.showRowSelectSg()) {
      <div
        class="atn-ds-table-data-row__cell atn-ds-table-data-row__cell--select"
      >
        <atn-ds-checkbox
          [selected]="
            store
              .ecSg()
              ?.plugins?.selectionPlugin?.feature?.selectors?.isSelected({
                entity: appliedRow.entity,
                target: store.selectionTargetSg(),
              })
              ?.asSignal() ?? false
          "
          (selectedChange)="
            store.changeRowSelection({
              entity: appliedRow.entity,
              isSelected: $event,
            })
          "
        />
      </div>
    }

    <!-- Render row cells -->
    @for (appliedCell of appliedRow.cells; track $index) {
      @let attributeId = appliedCell.attribute.id;
      @let width = store.getColumnWidthSg(attributeId)();
      @let config = store.getColumnConfigSg(attributeId)();

      <div
        [style.flex]="!width ? config.width.flex : undefined"
        [style.width.%]="!width ? config.width.percent : undefined"
        [style.text-align]="config.align"
        [style.width.px]="width ?? config.width.px"
        [ngStyle]="config.css"
        class="atn-ds-table-data-row__cell"
        [class.atn-ds-table-data-row__cell--clickable]="appliedCell.onClick"
        (click)="appliedCell.onClick && appliedCell.onClick()"
      >
        <div
          class="atn-ds-table-data-row__cell-content"
          [class.atn-ds-table-data-row__cell-content--wrapped]="
            store.isCellContentWrappedSg()
          "
        >
          <!--
          NOTE: In order to catch width of the cell content here, we create a
          flex container that takes up only as much space as the content takes.
          That means that we have to align content in this div, since our
          content is in a div that is not taking up the whole cell width.
        -->
          <div
            class="atn-ds-table-data-row__cell-container-wrapper"
            [class.atn-ds-table-data-row__cell-container-wrapper--justify-center]="
              config.align === 'center'
            "
            [class.atn-ds-table-data-row__cell-container-wrapper--justify-end]="
              config.align === 'right'
            "
          >
            <!--
            NOTE: This div is created so that we can measure width of content.
            Also serves as a block div that can detect overflow, since flex div
            is failing to do so. More of a workaround probably
          -->
            <div
              #measuredElement
              [id]="attributeId"
              class="atn-ds-table-data-row__cell-container"
            >
              <cell-renderer [cellConfig]="appliedCell" />
            </div>
          </div>
        </div>
      </div>
    }
    @if (store.hasIconsSg()) {
      <div
        [style.width.px]="store.iconsMaxWidthSg()"
        class="atn-ds-table-data-row__cell"
      >
        <div
          class="atn-ds-table-data-row__cell-content"
          [class.atn-ds-table-data-row__cell-content--wrapped]="
            store.isCellContentWrappedSg()
          "
        ></div>
      </div>
    }
    @let hoveredRowRef = store.hoveredRowRefSg();

    @if (hoveredRowRef?.iconsConfigs?.length && hoveredRowRef === appliedRow) {
      <div
        class="atn-ds-table-data-row__icons-renderer"
        [style.left.px]="iconsElOffsetLeftPositionSg()"
        [style.width.px]="store.iconsMaxWidthSg()"
      >
        <icons-renderer [rowConfig]="hoveredRowRef" />
      </div>
    }
  </div>
}
